// Base Imports
import React, { useRef } from "react";

// Package Imports
import { Formik, Form } from "formik";

// Component Imports
import FormField from "@components/utils/ui/FormField";
import ProfileFormField from "@components/utils/ui/ProfileFormField";

// Other Imports
import { findByFieldName } from "@framework/utils/app-util";

interface IProfileFormProps {
    readonly submitState: any;
    readonly formId: string;
    readonly schema: any;
    readonly initialValues?: any;
    readonly defaultValues?: any;
    readonly formFields: Array<any>;
    onChangeMobileNumber?: Function;
    onSubmit?: Function;
}

const ProfileForm = (props: IProfileFormProps) => {
    const profileFormRef: any = useRef(null);
    const
        {
            submitState,
            formId,
            schema,
            initialValues = null,
            defaultValues,
            formFields,
            onChangeMobileNumber = () => { },
            onSubmit = () => { },
        } = props;
    const initState = defaultValues
        ? Object.keys(defaultValues).length
            ? defaultValues
            : initialValues
        : initialValues;

    return (
        <Formik
            innerRef={profileFormRef}
            validationSchema={schema}
            initialValues={initialValues}
            onSubmit={(values: any) => {
                const payload = {
                    ...values,
                };
                onSubmit(payload);
            }}
        >
            {(context) => {

                const {
                    errors,
                    touched,
                    handleSubmit,
                    values,
                    handleChange,
                    setValues,
                    handleBlur,
                } = context;

                return (
                    <div className="flex flex-col justify-center w-full max-w-4xl py-5 pt-2 mx-auto items-flex-start">
                        <Form
                            id={formId}
                            className="w-full overflow-hidden"
                            onSubmit={handleSubmit}
                        >
                            <div className='grid grid-cols-1 sm:grid-cols-2 gap-x-4 mob-order'>
                                {
                                    (formFields?.length
                                        ? Array.from<any>([]).concat([
                                            findByFieldName(formFields, "fullName"),
                                        ])
                                        : [])?.map((item: any, idx: number) => (
                                            <ProfileFormField
                                                key={idx}
                                                context={context}
                                                item={item}
                                            />
                                        ))
                                }
                                {
                                    (formFields?.length
                                        ? Array.from<any>([]).concat([
                                            findByFieldName(formFields, "mobileNumber"),
                                        ])
                                        : [])?.map((item: any, idx: number) => (
                                            <ProfileFormField
                                                key={idx}
                                                context={context}
                                                item={item}
                                                // lastChildInFloatingContainer={<span
                                                //     onClick={() => onChangeMobileNumber(values[item?.name])}
                                                //     className='absolute font-semibold cursor-pointer text-orange text-14 right-3 top-6'
                                                // >
                                                //     Change
                                                // </span>}
                                            />
                                        ))
                                }
                                {
                                    (formFields?.length
                                        ? Array.from<any>([]).concat([
                                            findByFieldName(formFields, "email"),
                                            findByFieldName(formFields, "birthDate"),
                                        ])
                                        : [])?.map((item: any, idx: number) => (
                                            <ProfileFormField
                                                key={idx}
                                                context={context}
                                                item={item}
                                            />
                                        ))
                                }

                            </div>

                            <div className='w-full mt-4'>

                                {
                                    (formFields?.length
                                        ? Array.from<any>([]).concat([
                                            findByFieldName(formFields, "gender"),
                                        ])
                                        : [])?.map((item: any, idx: number) => (
                                            <div key={item?.name} className="w-full py-4 address-type">
                                                <FormField
                                                    context={context}
                                                    item={item}
                                                />
                                            </div>
                                        ))
                                }

                            </div>
                        </Form>
                    </div>

                )
            }}
        </Formik>
    );

};

export default ProfileForm;